import React from 'react';

export default function DownArrowIcon(props) {
    return (
        <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.53878 13.75L0.744578 0.250001L8.53879 8.25L16.333 0.25L8.53878 13.75Z" fill="white"/>
        </svg>
    );
}